import { render, staticRenderFns } from "./tab-notifications.vue?vue&type=template&id=5ccfcf1d&"
import script from "./tab-notifications.vue?vue&type=script&lang=js&"
export * from "./tab-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports